import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { ImageUploader } from '../components/ImageUploader'
import { ProjectList } from '../components/ProjectList'
import { Footer } from '../components/Footer'
import { useProjectStore } from '../store/projectStore'
import { Project } from '@pindd/types'
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card'

export function Home() {
  const navigate = useNavigate()
  const { setProject } = useProjectStore()
  const [projects, setProjects] = useState<Project[]>([])

  useEffect(() => {
    const saved = localStorage.getItem('pindd-projects')
    if (saved) {
      setProjects(JSON.parse(saved))
    }
  }, [])

  const handleNewProject = (base64: string, fileName: string) => {
    const newProject: Project = {
      id: Date.now().toString(),
      name: fileName.split('.')[0],
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      sourceImage: base64,
      pixelatedData: null,
      boardSize: null,
      colorMapping: [],
      pixelShape: 'round',
    }

    setProject(newProject)
    const updated = [...projects, newProject]
    setProjects(updated)
    localStorage.setItem('pindd-projects', JSON.stringify(updated))
    navigate('/pixelate')
  }

  const handleSelectProject = (project: Project) => {
    setProject(project)
    navigate('/pixelate')
  }

  return (
    <div className="min-h-screen bg-background">
      {/* Hero Section */}
      <section className="border-b bg-muted/40">
        <div className="container py-12 md:py-20">
          <div className="mx-auto max-w-2xl text-center">
            <img src="/logo.svg" alt="PinDD Logo" className="w-20 h-20 mx-auto mb-4" />
            <h1 className="text-3xl font-bold tracking-tight sm:text-4xl md:text-5xl">
              PinDD
            </h1>
            <p className="mt-4 text-lg text-muted-foreground">
              将图片转换为精美的拼豆图案
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="container py-8 md:py-12">
        <div className="mx-auto max-w-4xl space-y-8">
          {/* New Project */}
          <Card>
            <CardHeader>
              <CardTitle>新建项目</CardTitle>
              <CardDescription>上传图片开始创建拼豆设计</CardDescription>
            </CardHeader>
            <CardContent>
              <ImageUploader onUpload={handleNewProject} />
            </CardContent>
          </Card>

          {/* Projects List */}
          <Card>
            <CardHeader>
              <CardTitle>我的项目</CardTitle>
              <CardDescription>继续编辑之前的项目</CardDescription>
            </CardHeader>
            <CardContent>
              <ProjectList
                projects={projects}
                onSelect={handleSelectProject}
                onDelete={(id) => {
                  const updated = projects.filter((p) => p.id !== id)
                  setProjects(updated)
                  localStorage.setItem('pindd-projects', JSON.stringify(updated))
                }}
              />
            </CardContent>
          </Card>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  )
}
